import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import './assets/terminal.css'
import './assets/main.css'

// import './assets/terminal.css'
// import './assets/loan.css'

const app = createApp(App)
app.use(router)
app.mount('#app')
